var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubUsersIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 2.4375C7.1759 2.4375 2.4375 7.1759 2.4375 13C2.4375 18.8241 7.1759 23.5625 13 23.5625C18.8241 23.5625 23.5625 18.8241 23.5625 13C23.5625 7.1759 18.8241 2.4375 13 2.4375ZM10.4498 8.36977C11.0932 7.68777 11.9986 7.3125 13 7.3125C14.0014 7.3125 14.8987 7.69031 15.5446 8.37586C16.1992 9.07055 16.5176 10.0039 16.4425 11.0073C16.2921 13 14.7484 14.625 13 14.625C11.2516 14.625 9.7048 13 9.55754 11.0068C9.48289 9.99527 9.80078 9.05887 10.4498 8.36977ZM13 21.9375C11.8069 21.9383 10.6257 21.6995 9.52664 21.2352C8.42754 20.771 7.43285 20.0908 6.60156 19.2349C7.07767 18.556 7.6843 17.9787 8.38602 17.5368C9.68043 16.707 11.3186 16.25 13 16.25C14.6814 16.25 16.3196 16.707 17.6125 17.5368C18.3148 17.9785 18.9219 18.5558 19.3984 19.2349C18.5672 20.0909 17.5725 20.7712 16.4734 21.2354C15.3743 21.6996 14.1931 21.9384 13 21.9375Z",
    fill: "#373737"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubUsersIc);
export default __webpack_public_path__ + "static/media/sub_users_ic.70f185791c00e6e70186df4ab2eed96e.svg";
export { ForwardRef as ReactComponent };